//Library Imports
import Cookies from "js-cookie";
import store from "store";

//Local Imports
import { IMAGE_SERVICE_URL, IMAGE_SERVICE_URL_STAGING } from "constants/index";
import { INewArticlesItem } from "modules/Content/MyAccounts/interface";
import { IArticlesItem } from "./modules/Content/interfaces";
import { getQueryAllCampaigns, getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import { ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS, USER_DETAILS } from "constants/types";
import secureLocalStorage from "react-secure-storage";

interface KeyVal {
  [key: string]: string;
}

// create imageurl of article with backend image service to resize artucle image with face detection
export const getImageUrl = (imgUrl: string, width?: number, height?: number, articleId?: number) => {
  return `${IMAGE_SERVICE_URL}/returnimage/?url=${encodeURIComponent(
    imgUrl
  )}&width=${width}&height=${height}&articleid=${articleId}&detectface=true`;
};

export const getPersonImageUrl = (imgUrl: string, width?: number, height?: number, executiveid?: number) => {
  return `${IMAGE_SERVICE_URL_STAGING}/returnimagev2/?url=${encodeURIComponent(
    imgUrl
  )}&width=${width}&height=${height}&executiveid=${executiveid}&detectface=true&isupdate=true`;
};

//create chunks of array with articles based on chunk size passed
export const newsChunkArray = (myArray: INewArticlesItem[], chunk_size: number) => {
  var results = [];
  let myArray1 = [...myArray];
  while (myArray1.length) {
    results.push(myArray1.splice(0, chunk_size));
  }
  return results;
};

//create chunks of array with articles based on chunk size passed
export const chunkArray = (myArray: IArticlesItem[], chunk_size: number) => {
  var results = [];
  let myArray1 = [...myArray];
  while (myArray1.length) {
    results.push(myArray1.splice(0, chunk_size));
  }
  return results;
};

export const mapNewsArticlesList = (articles: INewArticlesItem[], sequence: number[]) => {
  let tmpArticleLists: Array<Array<INewArticlesItem>> = [];
  let currentIndex: number = 0;
  sequence.forEach((val: number, i: number) => {
    tmpArticleLists[i] = articles.slice(currentIndex, currentIndex + val);
    currentIndex = currentIndex + val;
  });
  return tmpArticleLists;
};
export const mapArticlesList = (articles: IArticlesItem[], sequence: number[]) => {
  let tmpArticleLists: Array<Array<IArticlesItem>> = [];
  let currentIndex: number = 0;
  sequence.forEach((val: number, i: number) => {
    tmpArticleLists[i] = articles.slice(currentIndex, currentIndex + val);
    currentIndex = currentIndex + val;
  });
  return tmpArticleLists;
};

// add param to current url
export const addUrlParams = (history: any, params: KeyVal[]) => {
  const urlParams = new URLSearchParams(window.location.search);
  params.forEach(function (obj) {
    Object.keys(obj).forEach(function (obj_key) {
      urlParams.append(obj_key, obj[obj_key]);
    });
  });

  history.push({ search: urlParams.toString() });
};

export const removeOnClickBubble = (e: any) => {
  if (!e) e = window.event;
  e.cancelBubble = true;
  if (e.stopPropagation) e.stopPropagation();
};

export const getAccessId = () => {
  const cookies = Cookies.get();
  if ("access_id" in cookies) {
    const access_id = cookies["access_id"];
    return access_id;
  }
  return "";
};

export const getQueryParam = (param: string) => {
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let searchParam = params.get(param);

  return searchParam ? searchParam : "";
};

export const getCSRFToken = () => {
  // return "hlhk1eRWyfjhYyyh0uybK1X7kW3oijYsQqF969DQIFfrAIOikpO0WQjIHCF6jl2j";
  return localStorage.getItem("csrfToken");
};

export const setCSRFToken = (token: string) => {
  return localStorage.setItem("csrfToken", token);
};

export const FromUTCEpochToMonthDayString = (utcEpoch: number) => {
  const date: Date = new Date(utcEpoch);
  return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
  // const date: Date = new Date(0);
  // date.setUTCSeconds(utcEpoch);
  // let [, month, day] = date.toISOString().split("-");
  // day = day.split("T")[0];
  // return `${month}/${day}`;
};
export const EpochToMonthDayString = (utcEpoch: number) => {
  const date: Date = new Date(utcEpoch);
  return `${date.getUTCMonth() + 1}/${date.getUTCDate()}`;
};

export const objectToQueryParams = (params: any) => {
  let str = [];
  for (let p in params) {
    if (params.hasOwnProperty(p)) {
      let value = params[p];
      if (Array.isArray(params[p])) {
        value = value.join();
      } else {
        value = encodeURIComponent(value);
      }
      str.push(encodeURIComponent(p) + "=" + value);
    }
  }
  return str.join("&");
};

export const objectToQueryParamsWithArray = (params: any) => {
  let str = [];
  for (let p in params) {
    if (params.hasOwnProperty(p)) {
      let value = params[p];

      if (Array.isArray(params[p])) {
        const paramArray = params[p].map((paramValue: any) => {
          return `${p}=${paramValue}`;
        });
        value = paramArray.join(`&`);
      } else {
        value = encodeURIComponent(value);
      }

      if (Array.isArray(params[p])) {
        str.push(value);
      } else {
        str.push(encodeURIComponent(p) + "=" + value);
      }
    }
  }
  return str.join("&");
};

export const getAllTimeDates = () => {
  let today = new Date();
  const end_date = today.toISOString().split("T")[0];
  // setting the start date manually as the analytics data being stored starting from June 1, 2018 as told by Hamza Ishaq - Afzal
  const start_date = "2018-06-01";
  return { start_date, end_date };
};

export const getQuarterDates = () => {
  let today = new Date();
  let qtr = new Date();
  qtr.setMonth(today.getMonth() - 3);
  qtr.setDate(today.getDate() + 1);
  const end_date = today.toISOString().split("T")[0];
  const start_date = qtr.toISOString().split("T")[0];
  return { start_date, end_date };
};

export const getMonthDates = () => {
  let today = new Date();
  let month = new Date();
  month.setDate(today.getDate() - 30);
  const end_date = today.toISOString().split("T")[0];
  const start_date = month.toISOString().split("T")[0];
  return { start_date, end_date };
};

export const getWeekDates = (week: number) => {
  let today = new Date();
  let weekdate = new Date();
  weekdate.setDate(today.getDate() - (week - 1));
  const end_date = today.toISOString().split("T")[0];
  const start_date = weekdate.toISOString().split("T")[0];
  return { start_date, end_date };
};

export const getDay = (days: number) => {
  let today = new Date();
  let day = new Date();
  day.setDate(today.getDate() - days);
  const end_date = today.toISOString().split("T")[0];
  const start_date = day.toISOString().split("T")[0];
  return { start_date, end_date };
};

export const getToday = () => {
  let yesterday = new Date();
  const todayInString = yesterday.toISOString().split("T")[0];
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayInString = yesterday.toISOString().split("T")[0];
  return { start_date: yesterdayInString, end_date: todayInString };
};

// a generic function to get the range of start and end dates depending on the value
// value can be "qtr", "month", "week" or "day"
export const getDateObject = (value: string | number) => {
  switch (value) {
    case "all":
      return getAllTimeDates();
    case "qtr":
      return getQuarterDates();

    case "month":
      return getMonthDates();

    case "week":
      return getWeekDates(7);

    case "day":
      return getToday();

    default:
      return {};
  }
};

export const getPlanType = () => {
  const planType = store.getState().user.planType;
  if (!planType) {
    const securedPlanType = secureLocalStorage.getItem("plantype");
    const planTypeEnc = localStorage.getItem("plantype");
    if (securedPlanType) {
      store.dispatch({ type: USER_DETAILS.SET_PLAN_TYPE, planType: securedPlanType });
      return securedPlanType as string;
    } else if (planTypeEnc) {
      store.dispatch({ type: USER_DETAILS.SET_PLAN_TYPE, planType: planTypeEnc });
      localStorage.removeItem("plantype");
      secureLocalStorage.setItem("plantype", planTypeEnc);
      return planTypeEnc as string;
    }
  } else {
    // sometime We didn't in local storage
    // and we get from API in that case we store value in local storage once a api give the plantype
    if (!secureLocalStorage.getItem("plantype") && !localStorage.getItem("plantype")) {
      secureLocalStorage.setItem("plantype", planType);
    } else if (localStorage.getItem("plantype")) {
      const plantypeEncypt = localStorage.getItem("plantype");
      localStorage.removeItem("plantype");
      if (plantypeEncypt) {
        secureLocalStorage.setItem("plantype", plantypeEncypt);
      }
    }
    return planType as string;
  }
  return "invalid" as string;
};

export const capitalizeFirstLetter = (string: string) => {
  // This function will capitalize the first Letter of the first word of any string passed as argument
  const stringToCapitalize = string.trim();
  return stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1);
};

export const isSmallScreen = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const devicePixelRatio = window.devicePixelRatio;
  return width <= 1439 || height <= 729 || devicePixelRatio === 1.25 ? true : false;
};

export const getQueryListId = () => {
  // get campaign id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let listId = params.get("list_id");
  return listId ? parseInt(listId) : 0;
};

export const getQueryContactId = () => {
  // get contact id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let contactId = params.get("contact_id");
  return contactId ? parseInt(contactId) : 0;
};

export const getQueryAccountId = () => {
  // get account id from url param or state
  let search = window.location.search;
  const params = new URLSearchParams(search);
  let accountId = params.get("account_id");
  return accountId ? parseInt(accountId) : 0;
};

export const convertSnakeCaseKeysToCamelCase = (snakeCaseObj: any) => {
  const snakeToCamel = (s: string) => s.replace(/(_\w)/g, (k) => k[1].toUpperCase());
  const camelCaseObj = Object.entries(snakeCaseObj)?.reduce((previousState: any, currentValue: any) => {
    const objectWithProperty: any = { ...previousState };
    if (Array.isArray(currentValue[1]) && currentValue[1] !== null) {
      objectWithProperty[`${snakeToCamel(currentValue[0])}`] = currentValue[1].map((item) =>
        convertSnakeCaseKeysToCamelCase(item)
      );
    } else if (typeof currentValue[1] === "object" && currentValue[1] !== null) {
      objectWithProperty[`${snakeToCamel(currentValue[0])}`] = convertSnakeCaseKeysToCamelCase(currentValue[1]);
    } else {
      objectWithProperty[`${snakeToCamel(currentValue[0])}`] = currentValue[1];
    }
    return objectWithProperty;
  }, {});
  return camelCaseObj;
};

export const formatConcepts = (concepts: any) => {
  return concepts?.map(({ text, relevance }: any) => {
    return {
      name: text,
      y: Math.floor(Number(relevance) * 100),
    };
  });
};

// set redirection path
export const setRedirectionPath = () => {
  const path = window.location.pathname + window.location.search;
  localStorage.setItem("redirectionPath", path);
};

// get redirection path
export const getRedirectionPath = () => {
  return localStorage.getItem("redirectionPath");
};

// reset redirection path
export const resetRedirectionPath = () => {
  localStorage.removeItem("redirectionPath");
};

export const validateName = (username: string) => {
  var usernameRegex = /^[a-zA-Z ']+$/;
  return usernameRegex.test(username);
};

export const setCookie = (key: any, value: any) => {
  const date = new Date(new Date().getTime());
  const opts: any = {
    expires: new Date(date.setMonth(date.getMonth() + 12)), // 12 months
    domain: ".xiqonline.com",
    secure: true,
    sameSite: "None",
  };
  Cookies.set(key, value, opts);
};

export const getURLDomainName = (url: string) => {
  var domainName = url.replace("http://", "").replace("https://", "").split(/[/?#]/)[0];
  if (domainName.includes("www.")) {
    domainName = domainName.replace("www.", "");
  }
  return domainName;
};

export const getDefaultTemplateStyleId = () => {
  const userData = store.getState().user.userData;
  const adminIds = [4708];
  if (userData && userData?.admin_id && adminIds.includes(userData.admin_id)) {
    return 2;
  }
  return 0;
};

export const addCommaToNumber = (num: string) => {
  let indexOfDot = num.indexOf(".");
  const startIndex = indexOfDot === -1 ? num.length - 1 : indexOfDot - 1;
  if (!num) {
    return "";
  }
  if (num.length === 0) {
    return "";
  }
  let numberWithComma = "";
  let count = 0;
  for (let i = startIndex; i >= 0; i--) {
    if (count !== 3) {
      numberWithComma = num[i] + numberWithComma;
      count += 1;
    } else if (count === 3) {
      numberWithComma = num[i] + "," + numberWithComma;
      count = 0;
    }
  }
  return indexOfDot === -1 ? numberWithComma : numberWithComma + num.substring(indexOfDot);
};

export const getFromBetween = {
  // this is a function that gets the text between two strings
  results: [],
  string: "",
  getFromBetween: function (sub1: string, sub2: string) {
    if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
    var SP = this.string.indexOf(sub1) + sub1.length;
    var string1 = this.string.substr(0, SP);
    var string2 = this.string.substr(SP);
    var TP = string1.length + string2.indexOf(sub2);
    return this.string.substring(SP, TP);
  },
  removeFromBetween: function (sub1: string, sub2: string) {
    if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
    var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
    this.string = this.string.replace(removal, "");
  },
  getAllResults: function (sub1: string, sub2: string) {
    // first check to see if we do have both substrings
    if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

    // find one result
    var result = this.getFromBetween(sub1, sub2);
    // push it to the results array
    this.results.push(result);
    // remove the most recently found one from the string
    this.removeFromBetween(sub1, sub2);

    // if there's more substrings
    if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
      this.getAllResults(sub1, sub2);
    } else return;
  },
  get: function (string: string, sub1: string, sub2: string) {
    this.results = [];
    this.string = string;
    this.getAllResults(sub1, sub2);
    return this.results;
  },
};

export const removeCampaignAndEmailQueryParams = () => {
  if (getQueryCampaignId() !== 0 && getQueryEmailId() !== 0) {
    if (store.getState().analyticsDashboard.changeInAssetIds === false) {
      return;
    }
    store.dispatch({
      type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.REMOVE_QUERY_PARAMS_SET,
    });
    const href = window.location.href;
    let url = new URL(href);
    let params = new URLSearchParams(url.search);
    params.delete("campaign_id");
    params.delete("email_id");
    const queryParams = params.toString().length > 0 ? "?" + params.toString() : "";
    const afterDomain = href.substring(href.lastIndexOf("/" + 1));
    const beforeDomain = afterDomain.split("?")[0];
    window.history.replaceState({}, "", beforeDomain + queryParams);
  }
};

export const removeAccountContactIdFromQueryParams = () => {
  if (getQueryAccountId() > 0 || getQueryContactId() > 0) {
    const href = window.location.href;
    let url = new URL(href);
    let params = new URLSearchParams(url.search);
    params.delete("account_id");
    params.delete("contact_id");
    const queryParams = params.toString().length > 0 ? "?" + params.toString() : "";
    return queryParams;
  }
};

export const removeAllCampaignsFromQueryParams = () => {
  if (getQueryAllCampaigns() === "true") {
    const href = window.location.href;
    let url = new URL(href);
    let params = new URLSearchParams(url.search);
    params.delete("allCampaigns");
    const queryParams = params.toString().length > 0 ? "?" + params.toString() : "";
    const afterDomain = href.substring(href.lastIndexOf("/" + 1));
    const beforeDomain = afterDomain.split("?")[0];
    window.history.replaceState({}, "", beforeDomain + queryParams);
  }
};

export const arrayComparator = (arr1: any[], arr2: any[]) => {
  // This function will return true if both arrays are equal

  // If lengths of array are not equal means
  // array are not equal
  if (arr1.length !== arr2.length) {
    return false;
  }

  // Sort both arrays
  arr1.sort();
  arr2.sort();

  // Linearly compare elements
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  // If all elements were same.
  return true;
};

export const addGillRoyIcon = () => {
  const node = document.querySelector(".body-element");
  if (node) node.classList.add("gillRoy-index");
};

export const removeGillRoyIcon = () => {
  const node = document.querySelector(".body-element");
  if (node && node.classList.contains("gillRoy-index")) node.classList.remove("gillRoy-index");
};

export const truncateFrontZeros = (inputNumber: string) => {
  const trimedNumber = inputNumber.trim();
  let indexWithoutZero = 0;
  for (let index = 0; index < trimedNumber.length; index++) {
    if (trimedNumber[index] === "0") {
      indexWithoutZero += 1;
    } else {
      break;
    }
  }
  return trimedNumber.substring(indexWithoutZero);
};
